
import Vue from "vue"
import { VueConstructor } from "vue/types/umd"
import { EventBus } from "@/plugins/eventBus"
import axios from "axios"
import DateTimePicker from '@/components/DateTimePicker.vue'
import format from 'date-fns/format'

const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm:ss'

export default (Vue as VueConstructor<Vue>).extend({
  name: "AvailabilityRequestDialog",
  components: {
    DateTimePicker
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedSW: {
      type: Array as () => string[],
      required: true
    }
  },
  data: () => ({
    loading: false,
    availabilityRequestDate: {
      dateObject: new Date(),
      dateString: "",
      timeString: ""
    },
    adaptTimeData: ':00'
  }),
  computed: {
    inputValue: {
      get(): boolean {
        return this.value
      },
      set(val: boolean) {
        this.$emit('input', val)
      }
    },
    selectedWorkersText(): string {
      const count = this.selectedSW.length;
      return count + ' ' + this.$vuetify.lang.t(`$vuetify.${count > 1 ? 'workers' : 'worker'}`);
    }
  },
  methods: {
    checkSelection() {
      // Display snackbar error and hide component if no super_worker in selection
      if (this.selectedSW.length === 0) {
        EventBus.$emit('snackbar', { message: this.$vuetify.lang.t('$vuetify.empty_selection'), color: 'error' })
        this.inputValue = false
        return false
      }
      return true
    },
    async submit() {
      this.loading = true;

      try {
        const requestData = {
          id: this.selectedSW,
          availability_request: `${this.availabilityRequestDate.dateString} ${this.availabilityRequestDate.timeString}${this.adaptTimeData}`
        };

        // Make API request
        await axios.post('/v1/workers/action', requestData);

        // Show success message
        EventBus.$emit('snackbar', {
          message: this.$vuetify.lang.t('$vuetify.availability_request_created'),
          color: 'success'
        });

        // Close dialog
        this.inputValue = false;

        // Emit completed event so parent can refresh data if needed
        this.$emit('completed');
      } catch (error) {
        EventBus.$emit('snackbar', { axiosError: error });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    inputValue(val: boolean) {
      if (val === true) {
        // Check if selection is empty when dialog opens
        if (!this.checkSelection()) return;

        // Reset the date when dialog opens
        this.availabilityRequestDate = {
          dateObject: new Date(),
          dateString: format(new Date(), DEFAULT_DATE_FORMAT),
          timeString: format(new Date(), DEFAULT_TIME_FORMAT).slice(0, 5)
        };
      }
    }
  }
})
